import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { handleResponse } from 'actions/actionHelpers';
import { fetchParakeyKeysForDomainId } from 'actions/parakey';
import { required } from 'form/validation';

import { TextField, showErrorOnBlur } from 'mui-rff';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';

const ParakeyStorageGroupLockConfigurationDataField = ({ name, label, storageSiteLockConfiguration }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [parakeyKeys, setParakeyKeys] = useState(undefined);

    useEffect(() => {
        let mounted = true;
        if(storageSiteLockConfiguration?.domainId) {
            setIsLoading(true);
            dispatch(fetchParakeyKeysForDomainId(storageSiteLockConfiguration.domainId))
                .then(handleResponse(
                    response => {
                        if(mounted) {
                            setParakeyKeys(response.payload);
                            setIsLoading(false);
                        }
                    },
                    response => {
                        if(mounted) {
                            setIsLoading(false);
                            setParakeyKeys([]);
                        }
                        return response.meta.response.status === 403
                            ? false // no dialog
                            : undefined; // default dialog
                    }
                ));
        } else {
            setIsLoading(false);
        }
        return () => {
            mounted = false;
        };
    }, [storageSiteLockConfiguration?.domainId]);

    if(isLoading) {
        return (
            <CircularProgress
                size={16}
                color="primary"
            />
        );
    }

    return (
        <TextField
            select
            name={name}
            label={label}
            size="small"
            variant="outlined"
            required
            fieldProps={{ validate: required }}
            showError={showErrorOnBlur}
        >
            {
                (parakeyKeys ?? []).map(o =>
                    <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>
                )
            }
        </TextField>
    );
};

ParakeyStorageGroupLockConfigurationDataField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    storageSiteLockConfiguration: PropTypes.object
};

export default ParakeyStorageGroupLockConfigurationDataField;
